import { render, staticRenderFns } from "./PlannerIntegrationBadge.vue?vue&type=template&id=6e59a72c&scoped=true"
import script from "./PlannerIntegrationBadge.vue?vue&type=script&lang=js"
export * from "./PlannerIntegrationBadge.vue?vue&type=script&lang=js"
import style0 from "./PlannerIntegrationBadge.vue?vue&type=style&index=0&id=6e59a72c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e59a72c",
  null
  
)

export default component.exports